import { ApplicationStore } from '../states'

export const updateAuth2FA: (state: ApplicationStore, payload: string) => ApplicationStore = (state, payload) => {
  return {
    ...state,
    auth2FA: payload,
  }
}

export const removeAuth2FA: (state: ApplicationStore) => ApplicationStore = (state) => {
  const newState: ApplicationStore = JSON.parse(JSON.stringify(state))

  delete newState.auth2FA
  return {
    ...newState,
  }
}
